module.exports = __webpack_public_path__ + "img/feedback.9b499d5b.svg";